export default "__VITE_ASSET__BEgJEY4C__"